import React, { Component } from 'react';
import { getFormattedDate } from '../../../../../helpers/FormatDate';
import {
   TimeframeManagerActions,
   TimeframeManagerContainer,
   TimeframeManagerDates,
   TimeframeManagerButton,
   TimeframeManagerNote,
   TimeframeDateImage,
   TimeframeDateButton
} from './TimeframeManager.styled';
import config from '../../../../../config';

interface ITimeframeManagerProps {
   availableTimes: string[];
   maximum: number;
   headers: string[];
   templateId: string;
   collectionId: string;
   toggleTimepicker;
   loadTimeframe;
   period: number;
   isMobile: boolean;
}

export default class TimeframeManager extends Component<
   ITimeframeManagerProps,
   {
      selectedHeaders: string[];
      attemptOverMax: boolean;
   }
> {
   constructor(props: ITimeframeManagerProps) {
      super(props);
      this.state = {
         selectedHeaders: [],
         attemptOverMax: false
      };
   }

   public render() {
      const { availableTimes, maximum, toggleTimepicker, period, loadTimeframe, templateId, collectionId, isMobile } = this.props;

      const maxReached = maximum === this.state.selectedHeaders.length;

      const toggleHeader = header => {
         if (this.state.selectedHeaders.includes(header)) {
            this.setState({
               attemptOverMax: false,
               selectedHeaders: this.state.selectedHeaders.filter(x => x !== header)
            });
         } else {
            if (!maxReached) {
               this.setState({
                  attemptOverMax: false,
                  selectedHeaders: [...this.state.selectedHeaders, header]
               });
            } else {
               this.setState({
                  attemptOverMax: true
               });
            }
         }
      };

      const cancel = () => {
         toggleTimepicker();
      };

      const formattedDate = value => {
         let dt = new Date(value);
         dt = new Date(dt.getTime() - dt.getTimezoneOffset() * 60 * 1000);
         return dt.getUTCMonth() + 1 + '/' + dt.getUTCDate() + '/' + dt.getUTCFullYear();
      };

      const timeframes = (times: string[]) => {
         if (times) {
            return times.map((time, index) => {
               let active = this.state.selectedHeaders.includes(time);
               let disabled = maxReached && !active;
               return (
                  <TimeframeDateButton
                     key={index}
                     buttonType='none'
                     disabledTimeframe={disabled}
                     data-analytics={`Timeframe-Select-` + formattedDate(time)}
                     onClick={() => toggleHeader(time)}
                  >
                     <TimeframeDateImage
                        width={20}
                        height={20}
                        alt='Timeframe-Checkbox'
                        src={`${config.baseName}/images/${active ? 'ChartPlotSelect' : 'ChartPlotNotSelect'}.svg`}
                     />
                     {getFormattedDate(time, period)}
                  </TimeframeDateButton>
               );
            });
         }
      };

      const applyActive = this.state.selectedHeaders.length > 0;

      const apply = () => {
         if (applyActive) {
            toggleTimepicker();
            loadTimeframe(this.state.selectedHeaders, templateId, collectionId);
         }
      };

      return (
         <TimeframeManagerContainer>
            <TimeframeManagerNote active={this.state.attemptOverMax}>Select a maximum of {maximum}</TimeframeManagerNote>
            <TimeframeManagerDates justifyContent='start' flexDirection='row' flexWrap spaceBetween={23}>
               {timeframes(availableTimes)}
            </TimeframeManagerDates>
            <TimeframeManagerActions flexDirection='row' justifyContent={isMobile ? 'center' : 'end'} spaceBetween={8}>
               <TimeframeManagerButton data-analytics='Timeframe-Cancel' aria-label='Cancel' size='m' active onClick={cancel}>
                  Cancel
               </TimeframeManagerButton>
               <TimeframeManagerButton data-analytics='Timeframe-Apply' aria-label='Apply' size='m' active={applyActive} onClick={apply}>
                  Apply
               </TimeframeManagerButton>
            </TimeframeManagerActions>
         </TimeframeManagerContainer>
      );
   }
}
